import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {getSubjects} from "../../../../Services/Subjects/SubjectServices"
import {createGamelevel,getCategoryDetails,updateCategory} from "../../../../Services/CategoryServices"
import { toast } from 'react-toastify';
import { handleFileValidation } from "../../../../utils/Api";

const CreateCategory = ({popupType,editDataid,reRender,isShow,close }) => {  
  const [isLoading, setIsloading] = useState(false);
  const handleClose     = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [subjects, setSubjects]           = useState([]); 
  const [gameLevelId, setGameLevelId] = useState('');
  const [gameSubjectId, setGameSubjectId] = useState('');
  const [categoryName, setCategoryName]   = useState('');
  const [levelOrder, serLevelOrder]       = useState('');
  const [asset,setAsset] = useState(null)
  const [gameSubjectIdError, setGameSubjectIdError] = useState(false);
  const [categoryNameError, setCategoryNameError]   = useState(false);
  const [levelOrderError, setLevelOrderError]       = useState(false);
  const [assetError, setAssetError]                 = useState(false);
  useEffect(() => { 
    if(popupType=="EDIT"){
      getCategoryDetails(editDataid).then((data)=>{
        if(data.status){
          setGameLevelId(data.data.level_id) 
          setGameSubjectId(data.data.game_subject_id) 
          setCategoryName(data.data.name) 
          serLevelOrder( data.data.order.toString())  
        }
      })
    } 
    getSubjects().then((data)=>{
      if(data.status){
        setSubjects(data.data) 
      }
    })
    setShow(isShow)
  }, []); 

  const handleFileChange = (e) => handleFileValidation(e, setAsset,setAssetError);
 
  const checkFormValidation =()=>{
    if(!asset && popupType=='CREATE'){
      setAssetError(!asset)   
    } 
    if (!gameSubjectId.trim() || !categoryName.trim() || !levelOrder.trim()  ) {
      setGameSubjectIdError(!gameSubjectId.trim());
      setCategoryNameError(!categoryName.trim())
      setLevelOrderError(!levelOrder.trim()) 
      return true;
    }  
    if(!asset && popupType=='CREATE'){
      return true;
    }
    return false;
  }
  const createformData=()=>{
    const formData = new FormData();
    formData.append('game_level_id',gameLevelId);
    formData.append('game_subject_id',gameSubjectId);
    formData.append('name', categoryName.trim());
    formData.append('levelorder', levelOrder);
    formData.append('picture', asset);
    return formData;
  }
  const handleUpdate = async (e) => {  
    if(checkFormValidation()){
     return ;
    }
   const formData=createformData(); 
    setIsloading(true)
    updateCategory(formData).then((Response)=>{ 
     setIsloading(false)
      if(Response.status){    
        toast.success(Response.message) 
        reRender()
        handleClose()
      }else{
        toast.error(Response.errorMessage)
      } 
    }) 
  };

  const handleSubmit = async (e) => {  
   if(checkFormValidation()){
    return ;
   }
   const formData=createformData();  
   setIsloading(true)
   createGamelevel(formData).then((Response)=>{ 
    setIsloading(false)
     if(Response.status){    
       toast.success(Response.message) 
       reRender()
       handleClose()
     }else{
       toast.error(Response.errorMessage)
     } 
   }) 
 };

  return ( 
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <h5 className="modal-title">{popupType=="EDIT"?'Update':'Add'} Category</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3">
            <div className="col-12 px-3">
              <label for="NewGameSubject" className="form-label required">Subject</label>
              <select
                className="form-control"
                id="NewGameSubject"
                name="game_subject_id"
                placeholder="Enter Subject Name"
                value={gameSubjectId}
                onChange={(e)=>{setGameSubjectIdError(false); setGameSubjectId(e.target.value)}}
              >
                <option value='' disabled={true}>--Select Subject--</option>
                {subjects.map((data)=>{
                  return (<>
                   <option value={data.id}>{data.name}</option>
                  </>)
                })}
              </select>
              <div className="new-game-category-name lnerror invalid-feedback"  style={{ display: gameSubjectIdError ? 'block' : 'none' }}>Please select a subject.</div>
          
            </div>
            <div className="col-12 px-3">
               <label for="NewGameCategoryName" className="form-label required">Name</label>
              <input value={categoryName} maxLength="35" onChange={(e)=>{setCategoryNameError(false); setCategoryName(e.target.value)}} name="name" type="text" className="form-control" id="NewGameCategoryName" placeholder="Enter Category Name" />
              <div className="new-game-category-name lnerror invalid-feedback"  style={{ display: categoryNameError ? 'block' : 'none' }}>Please provide name.</div>
            </div>
            <div className="col-12 px-3">
              <label for="ordernumber" className="form-label required">Order number</label>
              <input value={levelOrder}  name="levelorder" onChange={(e)=>{ setLevelOrderError(false);serLevelOrder(e.target.value)}} type="number" className="form-control" id="ordernumber" placeholder="Enter order number" min="1" max="99" />
              <div className="new-game-category-name onerror invalid-feedback"  style={{ display: levelOrderError ? 'block' : 'none' }}>Please provide order number.</div>
              <div className="new-game-category-name-validate onerror invalid-feedback">Please provide valid order number.</div>
            </div> 
            <div className="col-12 px-3">
              <label for="NewCategoryImage" className={`form-label ${popupType=='CREATE' && 'required'}`}>Select Category Icon</label>
              <input
               onChange={handleFileChange}
               accept=".png, .jpg, .jpeg"
                name="picture" type="file" 
                className="form-control" 
                id="NewCategoryImage"
                 />
              <div className="new-category-image invalid-feedback"   style={{ display: assetError ? 'block' : 'none' }}>Please provide image.</div>
              <div className="new-category-image-validate invalid-feedback">Please provide .png/.jpg/.jpeg format images only.</div>
            </div>
                  
          </form>       
        </Modal.Body>
        <Modal.Footer>
            <button
            type="button"
            id="closesubject"
            className="btn btn-secondary" 
            onClick={()=>handleClose()}
          >
            Close
          </button>
          <button
            id="createsubject"
            type="button"
            className="btn btn-primary"
            disabled={isLoading?true:false}
            onClick={popupType==='CREATE'?handleSubmit:handleUpdate}
          >
            {popupType==='CREATE'?'Save':'Update'}
          </button>
        </Modal.Footer>
      </Modal>
       
  );
};

export default CreateCategory;

